
jQueryCode = function(){

    jQuery(document).on("click", '.GTU-CookieSettings', function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        jQuery("#seers-cmp-cookie-policy-default-banner-content").addClass("seers-cmp-cookie-banner-active");
        jQuery("#seers-cmp-overlay").addClass("seers-cmp-overlay-active");
    });

    jQuery(document).on("click", '.seers-cmp-agree-button', function(event) {
                    
        //document.cookie = `rlx-consent=true; expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()}; path=/`;
        setCookie('rlx-consent', 'true', {'max-age': 31536000});
        if(document.getElementById("rlx-corner")){
            document.getElementById("rlx-corner").contentWindow.postMessage("consentTrue","https://corners.Rolex.com");
            document.getElementById("rlx-corner").contentWindow.postMessage("consentValidation","https://corners.Rolex.com");
        }
    });

    jQuery(document).on("click", '.seers-cmp-disagree-button', function(event) {
        
        //document.cookie = `rlx-consent=false; expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()}; path=/`;
        setCookie('rlx-consent', 'false', {'max-age': 31536000});
        if(document.getElementById("rlx-corner")){
            document.getElementById("rlx-corner").contentWindow.postMessage("consentFalse","https://corners.Rolex.com");
        }
    });

    jQuery(document).on("click", '#SeersCMPBannerSavePreferences', function(event) {
        
        
        if(jQuery('#seers-cmp-cookie-policy-preference-switch').is(":checked")){
            setCookie('rlx-consent', 'true', {'max-age': 31536000});
        }else{
            setCookie('rlx-consent', 'false', {'max-age': 31536000});
        }
        

        if(document.getElementById("rlx-corner") && jQuery('#seers-cmp-cookie-policy-preference-switch').is(":checked")){
            document.getElementById("rlx-corner").contentWindow.postMessage("consentTrue","https://corners.Rolex.com");
            document.getElementById("rlx-corner").contentWindow.postMessage("consentValidation","https://corners.Rolex.com");
        }else if(document.getElementById("rlx-corner") && !jQuery('#seers-cmp-cookie-policy-preference-switch').is(":checked")){
            document.getElementById("rlx-corner").contentWindow.postMessage("consentFalse","https://corners.Rolex.com");
        }
    });
    
}

var GTURolexConsent = localStorage.SeersCMPConsent ? JSON.parse(localStorage.SeersCMPConsent).value : false;

//console.log(JSON.parse(GTURolexConsent).pref);
if(localStorage.getItem("SeersCMPConsent")){
    if(JSON.parse(GTURolexConsent).pref){
        setCookie('rlx-consent', 'true', {'max-age': 31536000});
    }else{
        setCookie('rlx-consent', 'false', {'max-age': 31536000});
        //setCookie('rlx-corner-consent', 'false', {'max-age': 31536000});
    }
}else{
    setCookie('rlx-consent', 'false', {'max-age': 31536000});
    //setCookie('rlx-corner-consent', 'false', {'max-age': 31536000});
}

if(window.jQuery)  jQueryCode();
else{   
    var script = document.createElement('script'); 
    document.head.appendChild(script);  
    script.type = 'text/javascript';
    script.src = "//ajax.googleapis.com/ajax/libs/jquery/3.1.0/jquery.min.js";

    script.onload = jQueryCode;
}


waitForElm('#SeersCMPBannerSavePreferences').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important;";
});
waitForElm('.seers-cmp-disagree-button').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important; width: 200px !important;";
});
waitForElm('.seers-cmp-agree-button').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important; width: 200px !important;";
});
waitForElm('.seers-cmp-preference-btn').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important; width: 200px !important;";
});
waitForElm('.seers-cmp-policy-banner-text-links .seers-cmp-agree-button').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important;";
});
waitForElm('.seers-cmp-policy-banner-text-links .seers-cmp-disagree-button').then((elm) => {
    elm.style = "background: #222222 !important; color: #ffffff !important;";
});

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}


function setCookie(name, value, options = {}) {

  options = {
    path: '/',
    // add other defaults here if necessary
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}